import * as Sentry from "@sentry/react";
import { SENTRY_DSN } from "./src/constants/endpoints";

Sentry.init({
  dsn: SENTRY_DSN,
  sendDefaultPii: true,
  enableLogs: false,
});
